import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFunctions } from "firebase/functions";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const app = initializeApp({
  apiKey: "AIzaSyALFYjJ7c9wwXVwErlPYFE_mFS2-UgkeBU",
  appId: "1:905714237219:web:98d03b7c17613d7b969696",
  messagingSenderId: "905714237219",
  projectId: "vtuapp-9f0d7",
  authDomain: "vtuapp-9f0d7.firebaseapp.com",
  storageBucket: "vtuapp-9f0d7.firebasestorage.app",
  measurementId: "G-T14V98D9RM",
});

export const auth = getAuth(app);
export const functions = getFunctions(app, "us-central1");
export const db = getFirestore(app);
export const storage = getStorage(app);
